export default function (Alpine) {
    Alpine.directive('slide', slide);
    // If we're using a "minimum width", we'll need to disable
    // x-show's default behavior of setting display: 'none'.
    slide.inline = (el, { modifiers }) => {
        if (!modifiers.includes('min'))
            return;
        el._x_doShow = () => { };
        el._x_doHide = () => { };
    };
    function slide(el, { modifiers }) {
        let duration = modifierValue(modifiers, 'duration', 250) / 1000;
        let floor = modifierValue(modifiers, 'min', 0);
        let fullyHide = !modifiers.includes('min');
        if (!el._x_isShown)
            el.style.width = `${floor}px`;
        // We use the hidden attribute for the benefit of Tailwind
        // users as the .space utility will ignore [hidden] elements.
        // We also use display:none as the hidden attribute has very
        // low CSS specificity and could be accidentally overriden
        // by a user.
        if (!el._x_isShown && fullyHide)
            el.hidden = true;
        if (!el._x_isShown)
            el.style.overflow = 'hidden';
        // Override the setStyles function with one that won't
        // revert updates to the width style.
        let setFunction = (el, styles) => {
            let revertFunction = Alpine.setStyles(el, styles);
            return styles.width ? () => { } : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: 'width',
            transitionDuration: `${duration}s`,
            transitionTimingFunction: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        };
        el._x_transition = {
            in(before = () => { }, after = () => { }) {
                if (fullyHide)
                    el.hidden = false;
                if (fullyHide)
                    el.style.display = null;
                let current = el.getBoundingClientRect().width;
                el.style.width = 'auto';
                let full = el.getBoundingClientRect().width;
                if (current === full) {
                    current = floor;
                }
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: { width: current + 'px' },
                    end: { width: full + 'px' },
                }, () => el._x_isShown = true, () => {
                    if (el.style.width == `${full}px`) {
                        el.style.overflow = null;
                    }
                });
            },
            out(before = () => { }, after = () => { }) {
                let full = el.getBoundingClientRect().width;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: { width: full + 'px' },
                    end: { width: floor + 'px' },
                }, () => el.style.overflow = 'hidden', () => {
                    el._x_isShown = false;
                    // check if element is fully closed
                    if (el.style.width == `${floor}px` && fullyHide) {
                        el.style.display = 'none';
                        el.hidden = true;
                    }
                });
            },
        };
    }
}
function modifierValue(modifiers, key, fallback) {
    // If the modifier isn't present, use the default.
    if (modifiers.indexOf(key) === -1)
        return fallback;
    // If it IS present, grab the value after it: x-show.transition.duration.500ms
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue)
        return fallback;
    if (key === 'duration') {
        // Support x-slide.duration.500ms && duration.500
        let match = rawValue.match(/([0-9]+)ms/);
        if (match)
            return match[1];
    }
    if (key === 'min') {
        // Support x-slide.min.100px && min.100
        let match = rawValue.match(/([0-9]+)px/);
        if (match)
            return match[1];
    }
    return rawValue;
}
